import { useEffect } from "react";
import {
  resetAmplitude,
  setAmplitudeIdentify,
  setAmplitudeUserId,
} from "../../utils/amplitude"; // Adjust path to your new file
import { isVisitor, parseJwt } from "../../utils/help/user/user"; // Adjust path
import { useAppSelector } from "./useReduxHooks";

export const useAmplitudeTracker = () => {
  const token = useAppSelector((state: any) => state.userInfo.token);
  const restaurantInfo = useAppSelector(
    (state: any) => state.config.restaurantInfo
  );

  // This single useEffect handles setting/resetting the user ID
  useEffect(() => {
    if (token) {
      // User is logged in
      try {
        const decodedToken = parseJwt(token);
        if (decodedToken?.customer_id) {
          setAmplitudeUserId(decodedToken.customer_id);
        }
      } catch (error) {
        console.error("Failed to parse JWT for Amplitude:", error);
      }
    } else {
      // User is logged out or session expired
      resetAmplitude();
    }
  }, [token]);

  // This useEffect sets user properties once we have the token AND restaurant info
  useEffect(() => {
    if (token && restaurantInfo) {
      try {
        const decodedToken = parseJwt(token);
        if (decodedToken) {
          const identifyProperties = {
            customerId: isVisitor()
              ? "undefined"
              : `${decodedToken.customer_id}`,
            visitorId: isVisitor()
              ? `${decodedToken.customer_id}`
              : "undefined",
          };

          setAmplitudeIdentify(identifyProperties);
        }
      } catch (error) {
        console.error("Failed to set Amplitude identify properties:", error);
      }
    }
  }, [token, restaurantInfo]);
};
